import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import OtherFeesContainer from './OtherFeesContainer';

export default withRouter(injectIntl(OtherFeesContainer));
